var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "li040owzda",
    x1: "50%",
    x2: "50%",
    y1: "140.6%",
    y2: "-46.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C89C65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "87.6%",
    stopColor: "#F8CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD663"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#li040owzda)",
    fillRule: "nonzero",
    transform: "translate(-905 -294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.89 310.109c-21.478-21.479-56.302-21.479-77.781 0-21.479 21.48-21.479 56.303 0 77.782s56.303 21.479 77.782 0 21.479-56.303 0-77.782zm-12.183 30.029l-18.488 18.477-4.836 4.828-.1.1-7.79 7.795-20.845-20.84c-.203-.204-.39-.423-.561-.655-1.598-2.195-1.362-5.226.558-7.146l.014-.014c2.148-2.15 5.632-2.155 7.786-.01l2.062 2.05 7.815 7.775 3.217 3.21 23.372-23.365c1.393-1.393 3.424-1.937 5.327-1.427s3.389 1.997 3.898 3.9c.51 1.903-.035 3.934-1.428 5.327l-.001-.005z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f1581472.svg";
export { ForwardRef as ReactComponent };